import type { schemaType as StrapiEscapadasDetailSchemaType } from '~~/shared/api/strapi/escapadas/detail/schema'
import type { schemaType as StrapiCottagesPagechemaType } from '~~/shared/api/strapi/cottages-page/schema'
import type { propsInterface } from '~~/modules/design-system/sections/s-cta-card/s-cta-card-wrapper.vue'

export const useToSCtaCardWrapper = () => {
  const fromStrapiEscapadasDetail = (
    data: StrapiEscapadasDetailSchemaType,
  ): propsInterface | null => {
    const items: propsInterface['items'] = []

    if (data.attributes.image_banner) {
      for (const banner of data.attributes.image_banner) {
        if (banner.button) {
          items.push({
            image: banner.image.data.attributes.url,
            imageAlt: banner.title || '', // TODO: Cómo puede ser esto opcional?
            title: banner.title || '',
            subtitle: banner.text,
            link: banner.button.url as string,
            buttonText: banner.button.text as string,
          })
        }
      }
    }

    return { items }
  }

  const fromStrapiCottagesPage = (
    data: StrapiCottagesPagechemaType,
  ): propsInterface | null => {
    const items: propsInterface['items'] = []

    if (data.attributes.image_banner) {
      for (const banner of data.attributes.image_banner) {
        if (banner.button) {
          items.push({
            image: banner.image.data.attributes.url,
            imageAlt: banner.title || '',
            title: banner.title || '',
            subtitle: banner.text,
            link: banner.button.url as string,
            buttonText: banner.button.text as string,
          })
        }
      }
    }

    return { items }
  }

  return { fromStrapiEscapadasDetail, fromStrapiCottagesPage }
}
